export const copilotPresetAlerts = [
    'delete',
    'duplicate',
    'overwrite',
    'remove',
    'rename',
    'reset',
    'revert',
    'update',
] as const
export type CopilotPresetAlert = (typeof copilotPresetAlerts)[number]

export type CopilotPresetAlertInputSettings = {
    defaultValue?: string
    placeholder?: string
    required?: boolean
    visible: boolean
}

export const copilotPresetOptions = ['update', 'rename', 'duplicate', 'copy', 'delete', 'remove'] as const
export type CopilotPresetOption = (typeof copilotPresetOptions)[number]

export const copilotPresetSettings = ['tags', 'collections', 'rating', 'sourceUrl', 'username', 'visibility'] as const
export type CopilotPresetSetting = (typeof copilotPresetSettings)[number]

export type CopilotPresetSettings = Record<CopilotPresetSetting, boolean>
